import React, {Component} from "react";
import Route from 'react-router-dom/Route';
import {Switch} from "react-router-dom";

class Title extends Component{


    render(){
        const titles = [];
        const errorTitle = [];
        for (var i=0; i < this.props.pages.length; i++) {
            const title = this.props.pages[i].fields.title;
            if (this.props.pages[i].fields.default) {
                errorTitle.push(<Route key={i} render = {
                    () => {
                        return (<h1>{title}</h1>);
                    }
                }/>);
            }
            titles.push(<Route key={i} path={this.props.pages[i].fields.path} exact render = {
                () => {
                    return (<h1>{title}</h1>);
                }
            }/>);
        }
        return (
            <div id="page-header">
                <div className="page-title">
                    <Switch>
                    {
                        titles
                    }
                    {
                        errorTitle
                    }
                    </Switch>
                </div>
            </div>
        )
    }
}

export default Title


// WEBPACK FOOTER //
// ./src/components/content/main/Title.js